import React, { useEffect, useState } from 'react';
import './tableTransaction.css';
import {
  getAccountDropdown,
  getBusinessUnitDropdown,
  getExternalDropdown,
  getInternalDropdown,
  getProjectDropdown,
} from '../axios/MenuDropdownAxios';

function TableTransaction({
  items,
  columnMap,
  columnTypes,
  onAddRow,
  onDeleteRow,
  onChange,
  columnAction,
  journalTgl,
}) {
  const [dropdownData, setDropdownData] = useState([]);
  const [dropdownBunits, setDropdownBunits] = useState([]);
  const [dropdownExternal, setDropdownExternal] = useState([]);
  const [dropdownProject, setDropdownProject] = useState([]);
  const [dropdownInternal, setDropdownInternal] = useState([]);

  const fetchDropdownData = async () => {
    try {
      const data = await getAccountDropdown(); // Panggil fungsi Axios
      setDropdownData(data);
    } catch (error) {
      console.error('Error fetching dropdown data account', error);
    }
  };

  const fetchDropdownBunits = async () => {
    try {
      const data = await getBusinessUnitDropdown();
      setDropdownBunits(data);
    } catch (error) {
      console.error('Error fetching dropdown data business unit', error);
    }
  };

  const fetchDropdownExternal = async () => {
    try {
      const data = await getExternalDropdown();
      setDropdownExternal(data);
    } catch (error) {
      console.error('Error fetching dropdown data external', error);
    }
  };

  const fetchDropdownInternal = async () => {
    try {
      const data = await getInternalDropdown();
      setDropdownInternal(data);
    } catch (error) {
      console.error('Error fetching dropdown data internal', error);
    }
  };

  const fetchDropdownProject = async () => {
    try {
      const data = await getProjectDropdown();
      setDropdownProject(data);
    } catch (error) {
      console.error('Error fetching dropdown data project', error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
    fetchDropdownBunits();
    fetchDropdownExternal();
    fetchDropdownInternal();
    fetchDropdownProject();
  }, []);

  useEffect(() => {
    const updatedItems = items.map((item) => {
      const updatedItem = { ...item };

      if (!updatedItem.bunit && dropdownBunits.length > 0) {
        updatedItem.bunit = dropdownBunits[0].value;
      }
      if (!updatedItem.rkodepro && dropdownProject.length > 0) {
        updatedItem.rkodepro = dropdownProject[0].value;
      }
      if (!updatedItem.rkodeext && dropdownExternal.length > 0) {
        updatedItem.rkodeext = dropdownExternal[0].value;
      }
      if (!updatedItem.rkodeint && dropdownInternal.length > 0) {
        updatedItem.rkodeint = dropdownInternal[0].value;
      }

      return updatedItem;
    });

    if (JSON.stringify(items) !== JSON.stringify(updatedItems)) {
      if (onChange) onChange(updatedItems);
    }
  }, [
    dropdownBunits,
    dropdownProject,
    dropdownExternal,
    dropdownInternal,
    items,
    onChange,
  ]);

  const handleAddRow = () => {
    const newItem = {
      rkoderek: '',
      rdebet: 0,
      rkredit: 0,
      rreftgl: journalTgl,
      rrefterang: '',
      bunit: '',
      rkodepro: '',
      rkodeext: '',
      rkodeint: '',
      rkodeinv: '',
      rkodepo: '',
    };
    if (onAddRow) {
      onAddRow([...items, newItem]);
    }
  };

  const handleDeleteRow = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    if (onDeleteRow) onDeleteRow(updatedItems);
  };

  const columns = Object.keys(columnMap);

  const getInputType = (key) => {
    return columnTypes[key] || 'text'; // Default to 'text' if no type specified
  };

  const getInputProps = (key) => {
    if (columnTypes[key] === 'number') {
      return { min: 0 }; // Menambahkan min=0 untuk input tipe number
    }
    return {};
  };

  // Mencegah formulir untuk submit saat menekan Enter
  const handleKeyDown = (e) => {
    // Mencegah formulir untuk submit saat menekan Enter
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleKeyDown2 = (e) => {
    // Mencegah input titik (.)
    if (e.key === '.') {
      e.preventDefault();
    }
    // Mencegah formulir untuk submit saat menekan Enter
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  // Fungsi untuk memformat angka dengan pemisah ribuan
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <div>
      {!columnAction && (
        <button
          className="btn btn-primary mb-3"
          type="button"
          onClick={handleAddRow}
        >
          + Add Row
        </button>
      )}
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-sm">
          <thead className="table-secondary">
            <tr>
              {columns.map((key, index) => (
                <th key={index} className="table-header">
                  {columnMap[key]}
                </th>
              ))}
              {!columnAction && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  No journal data. Click "Add Row".
                </td>
              </tr>
            )}
            {items.map((item, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((key, colIndex) => (
                  <td
                    key={colIndex}
                    className="table-data"
                    title={
                      key === 'rkoderek'
                        ? dropdownData.find(
                            (option) => option.value === item.rkoderek
                          )?.label || ''
                        : key === 'bunit'
                        ? dropdownBunits.find(
                            (option) => option.value === item.bunit
                          )?.label || ''
                        : key === 'rkodepro'
                        ? dropdownProject.find(
                            (option) => option.value === item.rkodepro
                          )?.label || ''
                        : key === 'rkodeext'
                        ? dropdownExternal.find(
                            (option) => option.value === item.rkodeext
                          )?.label || ''
                        : key === 'rkodeint'
                        ? dropdownInternal.find(
                            (option) => option.value === item.rkodeint
                          )?.label || ''
                        : item[key]
                    }
                  >
                    {key === 'rkoderek' ? (
                      <>
                        <select
                          className="dropdown-search form-select form-select-sm"
                          value={item.rkoderek}
                          onChange={(e) => {
                            const value = e.target.value;
                            const updatedItem = { ...item, rkoderek: value };
                            const updatedItems = items.map((i, index) =>
                              index === rowIndex ? updatedItem : i
                            );
                            if (onChange) onChange(updatedItems);
                          }}
                          disabled={columnAction}
                          required
                        >
                          <option value="">Select an option</option>
                          {dropdownData.map((option, i) => (
                            <option key={i} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : key === 'bunit' ? (
                      <>
                        <select
                          className="dropdown-search form-select form-select-sm"
                          value={item.bunit}
                          onChange={(e) => {
                            const value = e.target.value;
                            const updatedItem = { ...item, bunit: value };
                            const updatedItems = items.map((i, index) =>
                              index === rowIndex ? updatedItem : i
                            );
                            if (onChange) onChange(updatedItems);
                          }}
                          disabled={columnAction}
                        >
                          {/* <option value="">Select an option</option> */}
                          {dropdownBunits.map((option, i) => (
                            <option key={i} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : key === 'rkodepro' ? (
                      <>
                        <select
                          className="dropdown-search form-select form-select-sm"
                          value={item.rkodepro}
                          onChange={(e) => {
                            const value = e.target.value;
                            const updatedItem = { ...item, rkodepro: value };
                            const updatedItems = items.map((i, index) =>
                              index === rowIndex ? updatedItem : i
                            );
                            if (onChange) onChange(updatedItems);
                          }}
                          disabled={columnAction}
                        >
                          {/* <option value="">Select an option</option> */}
                          {dropdownProject.map((option, i) => (
                            <option key={i} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : key === 'rkodeext' ? (
                      <>
                        <select
                          className="dropdown-search form-select form-select-sm"
                          value={item.rkodeext}
                          onChange={(e) => {
                            const value = e.target.value;
                            const updatedItem = { ...item, rkodeext: value };
                            const updatedItems = items.map((i, index) =>
                              index === rowIndex ? updatedItem : i
                            );
                            if (onChange) onChange(updatedItems);
                          }}
                          disabled={columnAction}
                        >
                          {/* <option value="">Select an option</option> */}
                          {dropdownExternal.map((option, i) => (
                            <option key={i} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : key === 'rkodeint' ? (
                      <>
                        <select
                          className="dropdown-search form-select form-select-sm"
                          value={item.rkodeint}
                          onChange={(e) => {
                            const value = e.target.value;
                            const updatedItem = { ...item, rkodeint: value };
                            const updatedItems = items.map((i, index) =>
                              index === rowIndex ? updatedItem : i
                            );
                            if (onChange) onChange(updatedItems);
                          }}
                          disabled={columnAction}
                        >
                          {/* <option value="">Select an option</option> */}
                          {dropdownInternal.map((option, i) => (
                            <option key={i} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : (
                      <input
                        className={`form-control form-control-sm ${
                          key === 'rdebet' || key === 'rkredit'
                            ? 'right-align'
                            : ''
                        }`} // key === 'rdebet' || key === 'rkredit' ? 'right-align' : ''
                        type={getInputType(key)} // Menentukan tipe input berdasarkan key
                        value={
                          key === 'rdebet' || key === 'rkredit'
                            ? formatNumber(item[key])
                            : key === 'rreftgl'
                            ? item[key] && !isNaN(new Date(item[key]).getTime())
                              ? new Date(item[key]).toLocaleDateString('en-CA')
                              : ''
                            : item[key]
                        }
                        onChange={(e) => {
                          let value = e.target.value;

                          // Jika kolom adalah rdebet atau rkredit, hapus nol di depan
                          if (key === 'rdebet' || key === 'rkredit') {
                            // Menghapus pemisah ribuan dan nol di depan
                            value = value.replace(/,/g, '').replace(/^0+/, '');
                            // Validasi untuk memastikan hanya angka positif yang diterima
                            if (
                              !/^\d*\.?\d*$/.test(value) ||
                              parseFloat(value) < 0
                            ) {
                              return; // Jika tidak valid, keluar dari fungsi
                            }
                          }

                          const updatedItem = { ...item, [key]: value };
                          const updatedItems = items.map((i, index) =>
                            index === rowIndex ? updatedItem : i
                          );
                          if (onChange) onChange(updatedItems);
                        }}
                        {...getInputProps(key)} // Menambahkan properti input seperti min untuk number
                        onKeyDown={
                          key === 'rdebet' || key === 'rkredit'
                            ? handleKeyDown2
                            : handleKeyDown
                        } // Menambahkan onKeyDown handler
                        disabled={columnAction}
                      />
                    )}
                  </td>
                ))}
                {!columnAction && (
                  <td className="table-action">
                    <button
                      className="btn btn-danger btn-sm"
                      type="button"
                      onClick={() => handleDeleteRow(rowIndex)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TableTransaction;
